export const transformUserAttributes = cognitoAttributes => {
  return cognitoAttributes.reduce((acc, attr) => {
    const {Name, Value} = attr;
    acc[Name] = Value;

    return acc;
  }, {})
};
